import { RootCpntIchr } from "../../../services/component/get-component/GetComponentResponse";
import { ErrorMessage } from "../../../util";
import { Option } from "../../../util/option";

export type RootComponentEditDialogState = {
  isShow: boolean;
  isEdit: boolean;
  isUpdated: boolean;
  rootComponent: RootComponent;
  spreadsheetSelectedRowIndex: number | undefined;
  formValidation: FormValidation;
  dataList: {
    cpntOwnType: Option[];
    cpntAlctnType: Option[];
    clodSrvc: Option[];
    clodSrvcRgn: Option[];
  };
  displayColumn: Option[];
  searchButtonDisabled: boolean;
  fieldPath: {
    rootCpntId: string;
    rootCpntName: string;
    dipByRgn: string;
    ownTypeCd: string;
    systemName: string;
    systemId: string;
    subSystemId: string;
    notSysUsg: string;
    alctnTypeCd: string;
    clodSrvcTypeCd: string;
    rgnTypeCd: string;
    acntName: string;
  };
};

export type SpreadsheetMessage = {
  messageId: string;
  message: string;
  column: string;
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type RootCpntIchrSpreadsheetRow = RootCpntIchr & SpreadsheetMessage;

export type SpreadsheetState = {
  rootCpntIchr: RootCpntIchrSpreadsheetRow[];
};
export type RootComponent = {
  rootCpntDelFlg: string;
  rootCpntId: string;
  rootCpntName: string;
  dipByRgn: string;
  ownTypeCd: string;
  systemName: string;
  systemId: string;
  subSystemId: string;
  notSysUsg: string;
  alctnTypeCd: string;
  clodSrvcTypeCd: string;
  rgnTypeCd: string;
  acntName: string;
  updateDateTimeMRootCpnt: string;
  rootCpntIchrList: RootCpntIchr[];
};

export type FormValidation = {
  rootCpntName: boolean;
  ownTypeCd: boolean;
  systemName: boolean;
  systemId: boolean;
  subSystemId: boolean;
  notSysUsg: boolean;
  alctnTypeCd: boolean;
  clodSrvcTypeCd: boolean;
  rgnTypeCd: boolean;
  acntName: boolean;
};

export type PageNewState =
  | RootComponentEditDialogState
  | ((prevState: RootComponentEditDialogState) => RootComponentEditDialogState);

export type RootCpntIchrKeys = keyof Omit<
  RootCpntIchr,
  "isChanged" | "updateDateTimeMRootCpntIchr"
>;
